import { checkForFeature } from 'utils/features';
import { COOKIE_PREFERENCE_TEST_MODE_FEATURE } from 'constants/features';

export const EU_VIEWER_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'GR',
  'ES',
  'FI',
  'FR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'GB',
  'TR',
  ...(checkForFeature(COOKIE_PREFERENCE_TEST_MODE_FEATURE) ? ['US'] : []),
];
